<template>
  <div class="page-wrapper">
    <div class="container-fluid p-0">
      <!-- login page start-->
      <div class="authentication-main">
        <div class="row">
          <div class="col-md-12">
            <div class="auth-innerright">
              <div class="authentication-box">
                <div class="text-center">
                  <img alt id="infralogo" src="../assets/infralogo.png" />
                </div>
                <div class="card mt-4">
                  <div class="card-body">
                    <div class="text-center">
                      <h4>Anmelden</h4>
                      <h6>Geben Sie E-Mail und Passwort ein.</h6>
                    </div>
                    <form class="theme-form">
                      <div class="form-group">
                        <label class="col-form-label pt-0">E-Mail</label>
                        <input
                          v-focus
                          class="form-control"
                          type="email"
                          name="userName"
                          id="userName"
                          v-model="inputUserName"
                          @keydown.enter="validateUser"
                        />
                      </div>
                      <div class="form-group">
                        <label class="col-form-label">Passwort</label>
                        <input
                          type="password"
                          id="userPassword"
                          v-model="inputUserPassword"
                          @keydown.enter="login"
                          autocomplete
                          class="form-control"
                          required
                        />
                      </div>
                      <div class="form-group form-row mt-3">
                        <button class="btn btn-primary btn-block" @click.prevent="validate" type="button">Login</button>
                      </div>
                      <router-link to="/forgotPassword">Passwort vergessen</router-link>
                      <div class="notices" v-if="this['auth/pwResetRequested']">
                        Bitte prüfen Sie Ihre E-Mails um das Zurücksetzen des Passworts abzuschließen.
                      </div>
                      <div id="loginErrors" class="errors" key="loginErrors">
                        <ul>
                          <transition-group name="fade" mode="out-in">
                            <li v-for="error in validationErrors" :key="error.errorMsg">{{ error.errorMsg }}</li>
                          </transition-group>
                        </ul>
                      </div>
                    </form>
                  </div>
                  <div class="specs">
                    * <strong>Zur Nutzung empfehlen wir :</strong> <br />- Google Chrome oder Mozilla Firefox <br />
                    - Bildschirm mit mindestens 1400px Breite
                    <br />
                    - Mobile und Ipad Displays können zu Anzeigeproblemen führen
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- login page end-->
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "Start",
  components: {},
  data: function() {
    return {
      validationErrors: [],
      userNameValidated: false,
      passwordValidated: false,
      inputUserName: "",
      inputUserPassword: "",
      showLoginAnimation: false,
    };
  },
  computed: {
    ...mapGetters([
      "auth/apiSettings",
      "auth/apiToken",
      "auth/apiStatus",
      "auth/isAuth",
      "auth/loginError",
      "auth/pwResetRequested",
      "auth/serverInfo",
      "app/animations",
      "auth/user",
    ]),
  },
  created() {
    console.log(`                 
                                  .:ccccccccc,                                  
                                 .dMMMMMMMMMM0'                                 
                                 .OMMMMMMMMMMN:                                 
                                 ;XMMMMMMMMMMMo                                 
                                 oWMMMMMMMMMMMk.                                
                   .,'.         .kMMMMMMMMMMMMK;         .',.                   
                   oNNX0kxoc;'..;KMMMMMMMMMMMMWl..';:ldk0KNWx.                  
                  :XMMMMMMMMMWX0KWMMMMMMMMMMMMMX0KNWMMMMMMMMNl                  
                 '0MMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMK,                 
                .xWMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMWx.                
                cNMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMNl                
                .cdOXWMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMWXOoc.                
                    .;lx0NMMMMMMMMMMMMMMMMMMMMMMMMMMMMN0xl;.                    
                        .'cdXMMMMMMMMMMMMMMMMMMMMMMKo:'.                        
                           :KMMMMMMMMMMMMMMMMMMMMMM0;                           
                         .oNMMMMMMMMMMMMMMMMMMMMMMMMXl.                         
                        .kWMMMMMMMMMMMMMMMMMMMMMMMMMMWx.                        
                       ;0WMMMMMMMMMMMMN0xKWMMMMMMMMMMMW0;                       
                      cXMMMMMMMMMMMMWO;. .lKWMMMMMMMMMMMXl.                     
                     cNMMMMMMMMMMMW0:.     .oXMMMMMMMMMMW0,                     
                     .;dKWMMMMMMW0c.         'dXMMMMMMNkc.                      
                        .:xXWMWKl.             'xNMWKo,                         
                           .:do.                 ,o:.
                                   
                                 made by I*AM`);
  },
  methods: {
    async login() {
      this.validationErrors = [];
      const { inputUserName, inputUserPassword } = this;
      await this.$store.dispatch("auth/login", {
        email: inputUserName,
        password: inputUserPassword,
      });

      if (this["auth/loginError"]) {
        this.validationErrors.push({
          errorId: 4,
          errorMsg: "Anmeldung fehlgeschlagen",
        });
      } else {
        this.redirectAfterLogin();
      }
    },
    validate() {
      this.validationErrors = [];
      this.validateUser();
      this.validatePassword();
      if (this.userNameValidated && this.passwordValidated) {
        this.login();
      }
    },
    async validatePassword() {
      this.passwordValidated = false;
      if (this.inputUserPassword.length) {
        this.passwordValidated = true;
      } else {
        this.validationErrors.push({
          errorId: 3,
          errorMsg: "Das Passwortfeld darf nicht leer sein.",
        });
      }
    },
    validateUser() {
      this.userNameValidated = false;
      if (this.inputUserName.length == 0) {
        this.validationErrors.push({
          errorId: 1,
          errorMsg: "Benutzer Email darf nicht leer sein.",
        });
        return;
      }
      let emailTest = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      let valid = emailTest.test(this.inputUserName);
      if (valid) {
        this.userNameValidated = true;
        this.validationErrors = [];
      } else {
        this.validationErrors.push({
          errorId: 2,
          errorMsg: "Bitte eine gültige Email-Adresse angeben.",
        });
      }
    },
    goBack() {
      this.userNameValidated = false;
      this.validationErrors = [];
    },
    redirectAfterLogin() {
      const isAdmin = this["auth/user"].role == 1 ? true : false;
      if (isAdmin) {
        this.$router.push("/admin/dashboard");
      } else {
        this.$router.push("/kunde/dashboard");
      }
    },
    debug() {
      console.log(this.loginError);
      console.log(this["auth/loginError"]);
    },
  },
  directives: {
    focus: {
      inserted: function(el) {
        el.focus();
      },
    },
  },
};
</script>

<style>
.welcomeMsg {
  margin: 30px 30px 30px 10px;
}

.specs {
  font-size: 0.7rem;
  text-align: left;
  color: lightgrey;
  padding: 10px;
}

#loginForm label {
  margin-right: 10px;
}

#loginContainer {
  padding: 50px;
  background: lightgrey;
  display: block;
  margin: 0 auto;
  margin-top: 15%;
  font-size: 1.5em;
}

.inputGroup input {
  height: 1.9em;
}

#prevArrow,
#nextArrow {
  display: inline-block;
  margin: 0 10px 0 10px;
  cursor: pointer;
}

#prevArrow svg path,
#nextArrow svg path {
  vertical-align: bottom;
}

.svg-inline--fa {
  height: 1.7em;
  vertical-align: middle;
}

.svg-inline--fa.fa-w-16 {
  width: 1.7em;
}

.inputGroup {
  display: inline-block;
}

.errors {
  color: red;
  font-size: 1.2em;
  padding: 10px;
  margin: 0;
}

.goodnews {
  color: green;
  font-size: 1.2em;
  padding: 10px;
  margin: 0;
}
#loginErrors ul {
  list-style-type: none;
}

.fade-enter-active {
  transition: all 0.3s;
}

.fade-leave-active {
  transition: all 0.3s;
}

.fade-enter,
.fade-leave-to {
  transform: translateX(-200px);
  opacity: 0;
  transition: all 0.3s;
}

#infralogo {
  width: 160px;
  height: auto;
  margin-top: -50px;
}

.inline-block {
  display: inline-block !important;
}

.block {
  display: block !important;
}
</style>
